import { get, getDatabase, ref, update } from 'firebase/database';
import React from 'react'
import { toast } from 'react-toastify';

const RenameStockCodeToMpn = () => {
    const renameStockCodeKey = async () => {
        const db = getDatabase();
        const productsRef = ref(db, 'Products');

        try {
            const snapshot = await get(productsRef);
            if (!snapshot.exists()) {
                console.log("No documents found in Products1");
                return;
            }
            for (const productDoc of Object.entries(snapshot.val())) {
                const productKey = productDoc[0];
                const productData = productDoc[1];
                console.log("Processing product:", productKey, productData);  // Log product data
                if (productData.stock_code) {
                    const updatedData = {
                        ...productData,  // Spread existing data to avoid overwriting other fields
                        mpn: productData.stock_code,
                        stock_code: null // Set to null to delete the field

                    };
                    await update(ref(db, `Products/${productKey}`), updatedData);
                    console.log(`Updated and removed stock_code for product: ${productKey}`);

                } else {
                    console.log("No stock_code field found for product:", productKey);  // If field is missing
                }
            }
            toast.success('Field renamed and stock_code deleted successfully!');
        } catch (error) {
            toast.error('Error renaming field: ' + error.message);
        }
    };

    return (
        <div>

            <h2>Rename Stock Code to MPN</h2>
            <button onClick={renameStockCodeKey}>Run Rename Script</button>
        </div>
    );
};

export default RenameStockCodeToMpn